import { Operation } from '../../../__generated__/globalTypes'

import {
  MinimalSponsorFragment,
  minimalSponsorFragmentString,
} from '../../fragments/__generated__/MinimalSponsorFragment'

import getStorefrontRawString from '../GetStorefront.graphql'

const getStorefrontString = [
  getStorefrontRawString,
  minimalSponsorFragmentString,
].join('\n\n')

export type GetStorefrontData = {
  user: MinimalSponsorFragment
}

export type GetStorefrontVariables = {
  slug: string
}

export type GetStorefront = Operation<GetStorefrontData, GetStorefrontVariables>

export const GetStorefront = ({
  slug,
}: GetStorefrontVariables): GetStorefront => ({
  query: getStorefrontString,
  variables: {
    slug,
  },
})
